/* w9-picker — buy-box option picker upgrades (2026-09-24). Loaded by snippets/variant-select-default.liquid.
   Data-driven from the product's own options and variants, so it serves every product that uses the dropdown
   picker: dropdown labels say what each value comes in ("48 TOOTH · 6 colors", "60 TOOTH · black only"); only the
   last dropdown carries a price, so a range never contradicts the price above it (Stanis, 2026-09-24),
   a hint row offers the sizes that do come in color, every color dot stays visible (faded when not made in the
   chosen size, slashed when sold out), the chosen color is named next to the label, and the selected ring is dark.
   The theme's own <variant-selects> cascade (assets/scripts.js) still owns the variant logic; this only decorates. */
(function () {
  'use strict';
  if (window.__w9pick) return; window.__w9pick = 1;

  var TOOTH = /(\d{1,3})\s*(?:T\b|TOOTH|TEETH)/i, NUM = /^\s*(\d{1,3})\s*$/;
  function teethOf(v) { if (v == null) return null; var m = TOOTH.exec(String(v)) || NUM.exec(String(v)); return m ? parseInt(m[1], 10) : null; }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function range(lo, hi) { return lo === hi ? money(lo) : money(lo) + '–' + money(hi).slice(1); }
  function shortColor(c) { return String(c).replace(/\b(anodized|anodised|powder\s*coat(ed)?)\b/ig, '').replace(/\s+/g, ' ').trim(); }
  function isRaw(c) { return /unfinished|raw|natural|none|plain/i.test(c); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(picker) {
    var optsEl = picker.querySelector('[data-id="product-options"]'), varsEl = picker.querySelector('[data-id="product-variants"]');
    if (!optsEl || !varsEl) return;
    var options, variants;
    try { options = JSON.parse(optsEl.textContent); variants = JSON.parse(varsEl.textContent); } catch (e) { return; }
    if (!Array.isArray(options) || !Array.isArray(variants) || !variants.length) return;
    var selects = Array.prototype.slice.call(picker.querySelectorAll('select'));
    if (selects.length !== options.length || selects.length < 1) return;
    var wraps = selects.map(function (s) { return s.closest('.product-form-input-dropdown'); });

    var ci = -1, ti = -1, bestN = 0;
    options.forEach(function (name, i) {
      if (ci < 0 && /colou?r|colore|couleur|finish/i.test(name)) ci = i;
      var seen = {}; variants.forEach(function (v) { seen[v.options[i]] = 1; });
      var keys = Object.keys(seen), n = keys.filter(function (k) { return teethOf(k) !== null; }).length;
      if (keys.length && n === keys.length && n > bestN) { bestN = n; ti = i; }
    });
    var pivot = ti >= 0 ? ti : -1;                       // the option a color is "made in"
    if (pivot < 0) for (var k = 0; k < options.length; k++) if (k !== ci) { pivot = k; break; }
    var dots = ci >= 0 && wraps[ci] ? wraps[ci].querySelector('.custom-color-swatches') : null;
    var labels = dots ? Array.prototype.slice.call(dots.querySelectorAll('label')) : [];

    function selected() { return selects.map(function (s) { return s.value; }); }
    function matchEarlier(v, i, sel) { for (var k = 0; k < i; k++) if (v.options[k] !== sel[k]) return false; return true; }
    function matchOthers(v, i, sel) { for (var k = 0; k < sel.length; k++) if (k !== i && v.options[k] !== sel[k]) return false; return true; }
    function valLabel(i, v) { var t = i === ti ? teethOf(v) : null; return t !== null ? t + 'T' : v; }

    // the last non-color dropdown is the final choice; only it shows a price
    var priceAt = -1;
    for (var p = selects.length - 1; p >= 0; p--) if (p !== ci) { priceAt = p; break; }

    // 1. dropdown labels: value + what it comes in (+ price on the final dropdown)
    function relabel() {
      var sel = selected();
      selects.forEach(function (s, i) {
        if (i === ci) return;
        Array.prototype.forEach.call(s.options, function (o) {
          var vs = variants.filter(function (v) { return v.options[i] === o.value && matchEarlier(v, i, sel); });
          if (!vs.length) { o.textContent = o.value; return; }
          var parts = [];
          if (ti >= 0 && i !== ti) {
            var teeth = uniq(vs.map(function (v) { return teethOf(v.options[ti]); }).filter(function (x) { return x !== null; })).sort(function (a, b) { return a - b; });
            if (teeth.length > 1) parts.push(teeth[0] + '–' + teeth[teeth.length - 1] + 'T'); else if (teeth.length === 1) parts.push(teeth[0] + 'T only');
          }
          if (ci >= 0) {
            var cols = uniq(vs.map(function (v) { return v.options[ci]; }));
            if (cols.length > 1) parts.push(cols.length + ' colors');
            else if (cols.length === 1) parts.push(isRaw(cols[0]) ? shortColor(cols[0]).toLowerCase() : shortColor(cols[0]).toLowerCase() + ' only');
          }
          if (i === priceAt) {
            var prices = vs.map(function (v) { return v.price; });
            parts.push(range(Math.min.apply(null, prices), Math.max.apply(null, prices)));
          }
          o.textContent = o.value.replace(/\s+/g, ' ') + (parts.length ? ' · ' + parts.join(' · ') : '');
        });
      });
    }

    // 2. hint under the pivot dropdown when the chosen value has no color choice but others do
    var pivotHint = null;
    function hintPivot() {
      if (ci < 0 || pivot < 0 || pivot === ci || !wraps[pivot]) return;
      if (!pivotHint) { pivotHint = el('div', 'w9-pick__hint'); wraps[pivot].appendChild(pivotHint); }
      pivotHint.innerHTML = '';
      var sel = selected(), s = selects[pivot];
      var here = uniq(variants.filter(function (v) { return v.options[pivot] === s.value && matchEarlier(v, pivot, sel); }).map(function (v) { return v.options[ci]; }));
      if (here.length > 1) return;
      var withColor = [];
      Array.prototype.forEach.call(s.options, function (o) {
        var cols = uniq(variants.filter(function (v) { return v.options[pivot] === o.value && matchEarlier(v, pivot, sel); }).map(function (v) { return v.options[ci]; }));
        if (cols.length > 1) withColor.push(o.value);
      });
      if (!withColor.length) return;
      pivotHint.appendChild(document.createTextNode('Want a color? This ' + (ti === pivot ? 'size' : 'option') + ' is ' + (here.length === 1 ? shortColor(here[0]).toLowerCase() + ' only' : 'one finish only') + '. Colors are made in'));
      withColor.forEach(function (val) {
        var b = el('button', 'w9-pick__chip', esc(valLabel(pivot, val))); b.type = 'button';
        b.addEventListener('click', function () { setSelect(pivot, val); });
        pivotHint.appendChild(b);
      });
    }

    // 3. color dots: state, selected ring, name, sold-out slash, not-made hint on click
    var colorHint = null, legend = null, nameSpan = null;
    function refreshDots() {
      if (!dots || ci < 0) return;
      var sel = selected(), cur = selects[ci].value;
      var curVs = variants.filter(function (v) { return v.options[ci] === cur && matchOthers(v, ci, sel); });
      labels.forEach(function (l) {
        var input = l.querySelector('input'); if (!input) return;
        var val = input.value;
        var vs = variants.filter(function (v) { return v.options[ci] === val && matchOthers(v, ci, sel); });
        var made = vs.length > 0, avail = vs.some(function (v) { return v.available; });
        l.classList.toggle('swatch-unavailable', !made);
        l.classList.toggle('w9-soldout', made && !avail);
        var isSel = val === cur; l.classList.toggle('selected', isSel); input.checked = isSel;
        var madeIn = pivot >= 0 && pivot !== ci ? uniq(variants.filter(function (v) { return v.options[ci] === val; }).map(function (v) { return valLabel(pivot, v.options[pivot]); })) : [];
        l.setAttribute('title', val + (!made ? ' — not made in this ' + (ti === pivot ? 'size' : 'option') + (madeIn.length ? ' (made in ' + madeIn.join(', ') + ')' : '') : (!avail ? ' — sold out' : '')));
        l.setAttribute('data-tooltip', l.getAttribute('title'));
      });
      var lab = wraps[ci] ? wraps[ci].querySelector('label[for]') : null;
      if (lab) {
        if (!nameSpan) { nameSpan = el('span', 'w9-pick__val'); lab.appendChild(nameSpan); }
        var soldOut = curVs.length > 0 && !curVs.some(function (v) { return v.available; });
        nameSpan.textContent = '— ' + cur + (soldOut ? ' · sold out' : '');
        nameSpan.classList.toggle('is-out', soldOut);
      }
      if (!legend && pivot >= 0 && pivot !== ci) {
        legend = el('div', 'w9-pick__legend', '<span><i></i>selected</span><span><i class="is-out"></i>sold out</span><span><i class="is-not"></i>not made in this ' + (ti === pivot ? 'size' : 'option') + ', tap to see where it is</span>');
        dots.parentNode.insertBefore(legend, dots.nextSibling);
      }
    }
    function showColorHint(color) {
      if (!dots || pivot < 0 || pivot === ci) return;
      if (!colorHint) { colorHint = el('div', 'w9-pick__hint'); dots.parentNode.insertBefore(colorHint, legend || dots.nextSibling); }
      colorHint.innerHTML = '';
      var vals = uniq(variants.filter(function (v) { return v.options[ci] === color; }).map(function (v) { return v.options[pivot]; }));
      if (!vals.length) return;
      var swLabel = labels.filter(function (l) { var i = l.querySelector('input'); return i && i.value === color; })[0];
      var sw = swLabel ? (swLabel.getAttribute('data-image') ? 'background-image:url(' + swLabel.getAttribute('data-image') + ')' : 'background-color:' + (swLabel.getAttribute('data-color') || '#999')) : '';
      colorHint.appendChild(el('span', null, '<b>' + esc(shortColor(color)) + '</b> comes in'));
      vals.forEach(function (val) {
        var b = el('button', 'w9-pick__chip', '<span class="w9-pick__sw" style="' + esc(sw) + '"></span>' + esc(valLabel(pivot, val))); b.type = 'button';
        b.addEventListener('click', function () { choose(color, val); colorHint.innerHTML = ''; });
        colorHint.appendChild(b);
      });
      colorHint.appendChild(document.createTextNode('— tap one to switch.'));
    }
    if (dots) dots.addEventListener('click', function (e) {
      var l = e.target && e.target.closest ? e.target.closest('label') : null;
      if (!l || !l.classList.contains('swatch-unavailable')) { if (colorHint) colorHint.innerHTML = ''; return; }
      e.preventDefault(); e.stopImmediatePropagation();
      var input = l.querySelector('input'); if (input) showColorHint(input.value);
    }, true);

    // setting values through the theme's own cascade
    var busy = false;
    function fire(s) { s.dispatchEvent(new Event('change', { bubbles: true })); }
    function setSelect(i, val) {
      if (busy) return; busy = true;
      try {
        var has = Array.prototype.some.call(selects[i].options, function (o) { return o.value === val; });
        if (!has) {
          var v = variants.filter(function (x) { return x.options[i] === val && x.available; })[0] || variants.filter(function (x) { return x.options[i] === val; })[0];
          if (v) selects.forEach(function (s, k) { if (k < i && s.value !== v.options[k]) { s.value = v.options[k]; fire(s); } });
        }
        if (selects[i].value !== val) { selects[i].value = val; fire(selects[i]); }
      } finally { busy = false; }
      refreshAll();
    }
    function choose(color, pivotVal) {
      var v = variants.filter(function (x) { return x.options[ci] === color && x.options[pivot] === pivotVal && x.available; })[0]
        || variants.filter(function (x) { return x.options[ci] === color && x.options[pivot] === pivotVal; })[0];
      if (!v) return;
      if (busy) return; busy = true;
      try { selects.forEach(function (s, k) { if (s.value !== v.options[k]) { s.value = v.options[k]; fire(s); } }); } finally { busy = false; }
      refreshAll();
    }

    var queued = false;
    function refreshAll() { if (queued) return; queued = true; setTimeout(function () { queued = false; relabel(); hintPivot(); refreshDots(); }, 0); }
    picker.addEventListener('change', function () { if (!busy) refreshAll(); });
    if (window.MutationObserver) selects.forEach(function (s) { new MutationObserver(function () { if (!busy) refreshAll(); }).observe(s, { childList: true }); });
    refreshAll();
    setTimeout(refreshAll, 300);   // after the theme's own DOMContentLoaded swatch pass
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('variant-selects'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();